import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export function CartProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [totalQuantityHeader, setTotalQuantityHeader] = useState(0);
  // 🏪 Estado inicial no contexto
  const [totalPlacedInCart, setTotalPlacedInCart] = useState({});

  // 🚀 Adicione este `useEffect` logo após a inicialização do estado
  useEffect(() => {
    console.log("🧐 Estado inicial de totalPlacedInCart:", totalPlacedInCart);
  }, [totalPlacedInCart]);


  const [cart, setCart] = useState(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart"));
    console.log("🔍 Carrinho carregado do localStorage:", storedCart);
    return storedCart || [];
  });

  // Atualizar totalPlacedInCart com base no estado inicial do carrinho
  useEffect(() => {
    console.log("🧐 Atualizando totalPlacedInCart com base no carrinho inicial:", cart);

    // ✅ Verifica se `cart` está definido antes de acessar `.reduce()`
    if (!cart || cart.length === 0) {
      console.log("⚠️ Carrinho ainda está vazio ou indefinido, esperando atualização...");
      return;
    }

    const initialTotalPlacedInCart = cart.reduce((acc, item) => {
      acc[item.product.id] = item.quantityInCart || 0;
      return acc;
    }, {});

    setTotalPlacedInCart(initialTotalPlacedInCart);

    console.log("✅ Novo totalPlacedInCart inicializado:", initialTotalPlacedInCart);
  }, [cart]); // 🔥 O efeito agora só roda quando `cart` está pronto



  // Salvar o carrinho no localStorage sempre que o carrinho for alterado
  useEffect(() => {
    //console.log("Salvando carrinho no localStorage:", cart);
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  function addToCart(product) {
    setCart((currentCart) => {
      const existingItem = currentCart.find(
        (item) => item.product.id === product.id
      );

      if (existingItem) {
        // Se o item já existir no carrinho, aumenta a quantidade
        const updatedCart = currentCart.map((item) =>
          item.product.id === product.id
            ? { ...item, quantityInCart: Math.min(item.quantityInCart + 1, 10) } // Limita a quantidade a 10
            : item
        );
        console.log("Produto adicionado ao carrinho:", updatedCart);
        return updatedCart;
      } else {
        // Se o item não existir no carrinho, adiciona-o
        const newCart = [...currentCart, { product, quantityInCart: 1 }];
        //console.log("Produto adicionado ao carrinho:", newCart);
        return newCart;
      }
    });
  }

  // Atualiza a quantidade disponível antes de atualizar o carrinho
  const updateQuantityAvailable = (productId, quantityChanged) => {
    setTotalPlacedInCart((prevTotal) => {
      const updatedTotal = {
        ...prevTotal,
        [productId]: (prevTotal[productId] || 0) + quantityChanged,
      };
      //console.log("Quantidade disponível atualizada:", updatedTotal);
      return updatedTotal;
    });
  };

  function updateQuantityInCart(productId, newQuantity) {
    setCart((currentCart) => {
      const existingItem = currentCart.find(
        (item) => item.product.id === productId
      );

      if (existingItem && existingItem.quantityInCart) {
        const quantityDifference = newQuantity - existingItem.quantityInCart;
        // Atualiza a quantidade disponível
        updateQuantityAvailable(productId, quantityDifference);
      }

      const updatedCart = currentCart.map((item) =>
        item.product.id === productId
          ? { ...item, quantityInCart: newQuantity }
          : item
      );
      console.log("Quantidade no carrinho atualizada:", updatedCart);
      return updatedCart;
    });
  }

  function removeFromCart(productId) {
    setCart((currentCart) => {
      const itemToRemove = currentCart.find(
        (item) => item.product.id === productId
      );

      if (itemToRemove) {
        // Atualiza a quantidade disponível ao remover o item do carrinho
        updateQuantityAvailable(productId, -itemToRemove.quantityInCart);
      }

      const updatedCart = currentCart.filter(
        (item) => item.product.id !== productId
      );
      console.log("Produto removido do carrinho:", updatedCart);
      return updatedCart;
    });
  }

  useEffect(() => {
    const totalQtd = cart.reduce((totalQtd, item) => {
      return totalQtd + item.quantityInCart;
    }, 0);

    localStorage.setItem("totalQuantityHeader", totalQtd);
    setTotalQuantityHeader(totalQtd);
  }, [cart]);

  return (
    <CartContext.Provider
      value={{
        setTotalQuantityHeader,
        totalQuantityHeader,
        products,
        setProducts,
        cart,
        setCart,
        addToCart,
        updateQuantityInCart,
        removeFromCart,
        totalPlacedInCart,
        setTotalPlacedInCart,
        updateQuantityAvailable,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}
